<template>
    <div>
        <SubHeader :text="$t('h.news')" :imgUrl="img" />
        <div class="box">
            <New
                :img="newImg1"
                title="SD-WAN技术如何提高企业网络沟通效率"
                text="几十年来企业通过部署DDN, Frame Relay和MPLS等广域网技术保证其商业数据的高质量转发。近年，随着云架构DC和混合架构DC的广泛应用，同时大数据和实时商业数据传输的需求越来越多，传统的专线连接技术已经不能满足客户快速部署商业应用和连接的需求。"
                time="2020-08-14"
                id="2"
            />
            <New
                :img="newImg"
                title="深圳睿网云联科技有限公司的云快线智能组网产品分别通过SD-WAN Ready的设备、解决方案以及服务认证"
                text="2020年6月2日--6月29日，深圳睿网云联科技有限公司（以下简称“睿网云联”）参加了由CCSA SNAI推委会（TC610）SDN集成与互通测试组发起的“SD-WAN Ready”测试项目，并已顺利通过该项测试。通过此次测试，表明睿网云联SD-WAN产品的技术规范性和专业性得到了充分肯定。截止目前，已有中国联通、电信国际、移动国际、华为、思科、奇安信、香港电讯等多家企业通过“SD-WAN Ready”项目测试。"
                time="2020-06-29"
                id="1"
            />

            <!-- <New
                :img="newImg"
                title="如何快速提升APP运营能力？"
                text="越来越多的移动应用企业采用APP消息推送的手段，提升用户活跃度，增加用户粘性，探索和越来越多的移动应用企业采用APP消息推送的手段，提升用户活跃度，增加用户粘性，探索和...越来越多的移动应用企业采用APP消息推送的手段，提升用户活跃度，增加用户粘性，探索和越来越多…"
                time="2020-7-3"
                id="new-2"
            />
            <New
                :img="newImg"
                title="如何快速提升APP运营能力？"
                text="越来越多的移动应用企业采用APP消息推送的手段，提升用户活跃度，增加用户粘性，探索和越来越多的移动应用企业采用APP消息推送的手段，提升用户活跃度，增加用户粘性，探索和...越来越多的移动应用企业采用APP消息推送的手段，提升用户活跃度，增加用户粘性，探索和越来越多…"
                time="2020-7-3"
                id="new-3"
            />
            <New
                :img="newImg"
                title="如何快速提升APP运营能力？"
                text="越来越多的移动应用企业采用APP消息推送的手段，提升用户活跃度，增加用户粘性，探索和越来越多的移动应用企业采用APP消息推送的手段，提升用户活跃度，增加用户粘性，探索和...越来越多的移动应用企业采用APP消息推送的手段，提升用户活跃度，增加用户粘性，探索和越来越多…"
                time="2020-7-3"
                id="new-4"
            />
            <New
                :img="newImg"
                title="如何快速提升APP运营能力？"
                text="越来越多的移动应用企业采用APP消息推送的手段，提升用户活跃度，增加用户粘性，探索和越来越多的移动应用企业采用APP消息推送的手段，提升用户活跃度，增加用户粘性，探索和...越来越多的移动应用企业采用APP消息推送的手段，提升用户活跃度，增加用户粘性，探索和越来越多…"
                time="2020-7-3"
                id="new-5"
            /> -->
            <div class="pages">
                <!-- <img
                    class="pages-item not"
                    :src="require('@/assets/img_svg/forward.svg')"
                    alt="svg"
                />
                <img
                    class="pages-item"
                    :src="require('@/assets/img_svg/forward.svg')"
                    alt="svg"
                /> -->
            </div>
        </div>
    </div>
</template>
<script>
import SubHeader from "@/components/SubHeader.vue";
import New from "@/components/New.vue";
import initAnimation from "../animation";
export default {
    data() {
        return {
            img: require("@/assets/images/sub_page_banner_9.jpg"),
            newImg: require("@/assets/images/news/new.png"),
            newImg1: require("@/assets/images/news/sudu.jpeg"),
        };
    },
    components: {
        SubHeader,
        New,
    },
    mounted() {
        setTimeout(initAnimation, 0);
    },
};
</script>
<style scoped>
.box {
    width: 1200px;
    margin: auto;
    padding: 0 10px;
    box-sizing: border-box;
}
.pages {
    width: 100px;
    height: 14px;
    margin: 85px auto 85px;
    display: flex;
    justify-content: space-between;
}
.pages-item {
    width: 29px;
    height: 14px;
    cursor: pointer;
}
.not {
    transform: rotate(180deg);
}
</style>



// WEBPACK FOOTER //
// src/Pages/News/News.vue